const NavItem = ({ title, Icon }) => {
  return (
    <>
      <Icon />
      <span className="title">{title}</span>
    </>
  )
}

export default NavItem
